import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {VIEWER_MENU_STATE_NAME} from '../constant/viewerConstant';
import {ViewerMenuState} from './ViewerMenuState.interface';

export const viewerMenuSlice = createSlice({
  name: VIEWER_MENU_STATE_NAME,
  initialState: {
    isExposed: false,
  } as ViewerMenuState,
  reducers: {
    setIsViewerMenuExposed: (
      state,
      action: PayloadAction<{
        isExposed: boolean;
        // 뷰어메뉴는 앱 인터페이스에 의해 띄우는 경우가 있으므로 이를 판별하기 위한 값입니다.
        isInvokedByApp?: boolean;
      }>
    ) => {
      state.isExposed = action.payload.isExposed;
    },
  },
});

export const {setIsViewerMenuExposed} = viewerMenuSlice.actions;
